import './price-estimator-dialog.scss';

import classNames from 'classnames';
import type { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Button, Dialog } from '@ctct/payflow-ui';

import {
  PriceEstimatorDialogContacts,
  PriceEstimatorDialogPricing,
  PriceEstimatorDialogTier,
} from './PriceEstimatorDialogTier';
import { PriceEstimatorTable } from './PriceEstimatorTable';
import { stringToPriceEstimatorDialogPlanType, type PriceEstimatorDialogI18nKeys } from './types';

interface Props {
  className?: string;
  onClose(): void;
  children?: ReactNode;
  isLoading?: boolean;
  planType: string;
  i18nKeys: PriceEstimatorDialogI18nKeys;
}

export const PriceEstimatorDialog = Object.assign(
  ({ className = '', onClose, children, isLoading = false, planType: planTypeString, i18nKeys: i18n }: Props) => {
    const { t } = useTranslation();

    const planType = stringToPriceEstimatorDialogPlanType(planTypeString);

    return (
      <Dialog
        data-qe-id="price-estimator-dialog"
        className={classNames('payflow-presentation payflow-price-estimator-dialog', className)}
        open
        title={t(i18n.heading)}
        footer={
          <div className="footer-button-container">
            <Button data-qe-id="price-estimator-ok-button" variant="primary" onClick={onClose}>
              {t(i18n.ok)}
            </Button>
          </div>
        }
        onOpenChange={onClose}
        content={
          <>
            <PriceEstimatorTable isLoading={isLoading} i18nKeys={i18n} planType={planType}>
              {children}
            </PriceEstimatorTable>
            <div className="overage-message-container">
              <Trans i18nKey={i18n.overageMessage}>
                <a
                  href="https://knowledgebase.constantcontact.com/articles/KnowledgeBase/46046-Constant-Contact-s-email-send-limit-and-overage-fee?lang=en_US"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View more details
                </a>
              </Trans>
            </div>
          </>
        }
      />
    );
  },
  {
    TierRow: PriceEstimatorDialogTier,
    ContactsCell: PriceEstimatorDialogContacts,
    PricingCell: PriceEstimatorDialogPricing,
  }
);

export { PriceEstimatorDialogPlanType } from './types';
